import { LiveTv } from '@mui/icons-material';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CardActionsTitleText } from '~/components/cards';
import { Link } from '~/components/link';
import { GridCard } from '~/components/media/card';
import { useLink } from '~/hooks/link';
import type { LiveChannels__Channel as Channel } from '../queries/list.generated';

interface ChannelCardProps {
  channel: Channel;
}

export const ChannelCard = ({ channel }: ChannelCardProps) => {
  const { t } = useTranslation();
  const link = useLink();

  return (
    <GridCard>
      <Link to={link(`/live-channels/${channel.id}`)} color="inherit" underline="none">
        <Box
          sx={{
            position: 'relative',
            '&::before': {
              content: '""',
              display: 'block',
              paddingBottom: 'calc(100% / 16 * 9)',
            },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: '100%',
              width: '100%',
              // eslint-disable-next-line no-restricted-syntax -- fallback for a user-picked channel color
              backgroundColor: channel.backgroundColor || '#f8f8f8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {channel.thumbnailFile.uri ? (
              <Box
                component="img"
                src={channel.thumbnailFile.uri}
                alt={channel.name}
                sx={{
                  maxHeight: '70%',
                  maxWidth: '70%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <LiveTv sx={{ fontSize: 48, color: 'text.secondary' }} />
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            p: 1.5,
            pb: 1,
            pr: 1,
            borderTop: 1,
            borderTopColor: 'borders.light',
          }}
        >
          <CardActionsTitleText title={channel.name} />
          <Chip
            label={t('pages.live_channels.channel_abbreviation', {
              number: channel.number,
            })}
            size="small"
            color="primary"
          />
        </Box>
      </Link>
    </GridCard>
  );
};
